export default __webpack_public_path__ + "static/media/welcome_bg_gradient.2c443aed.png";